import { Link, Navigate, useParams } from "react-router-dom";
import { EVENT_KINDS, EVENT_SCOPES, canSeeContent, getVisibility, labelFor, listEvents } from "@hub";
import { appUrl } from "../config";
import { useHubVisitor, withVisitor } from "../hubContext";

export default function EventDetail() {
  const { id } = useParams();
  const visitor = useHubVisitor();
  const visibility = getVisibility();
  const event = listEvents().find((item) => item.id === id);
  if (!event) return <Navigate to={withVisitor("/events", visitor)} replace />;
  if (visibility.events === false || !canSeeContent(event.visibility, visitor.role)) {
    return (
      <article>
        <h1>Event</h1>
        <p className="lead">This listing is hidden for your current role.</p>
        <p>
          <Link to={withVisitor("/events", visitor)}>Back to events</Link>
        </p>
      </article>
    );
  }

  return (
    <article>
      <p className="muted">
        <Link to={withVisitor("/events", visitor)}>Events</Link>
        {" · "}
        <Link to={withVisitor("/calendar", visitor)}>Calendar</Link>
      </p>
      <h1>{event.title}</h1>
      <p className="lead">{event.summary}</p>
      <div className="card-grid">
        <section className="card">
          <h2>When</h2>
          <p>
            {event.starts_on} {event.starts_at ? `· ${event.starts_at}` : ""}
          </p>
          <p className="muted">{labelFor(EVENT_SCOPES, event.scope)}</p>
        </section>
        <section className="card">
          <h2>Where</h2>
          <p>{event.location || "Location placeholder"}</p>
          <p className="muted">{event.region || "San Diego County"}</p>
        </section>
        <section className="card">
          <h2>Category</h2>
          <p>{labelFor(EVENT_KINDS, event.kind)}</p>
          <p className="muted">Visibility: {event.visibility || "public"}</p>
        </section>
      </div>
      {event.url ? (
        <p>
          <a href={event.url} target="_blank" rel="noreferrer">
            External details
          </a>
        </p>
      ) : (
        <p className="placeholder-note">External link placeholder. Add a URL from Admin Controls when you have one.</p>
      )}
      <p>
        This event also appears on the DreamHomeJourney calendar. When it is relevant to the office,
        it appears on the REChecklist agent or broker calendar without writing a second copy.
      </p>
      <p>
        <a href={appUrl("/agent/calendar")}>REChecklist calendar</a>
      </p>
    </article>
  );
}
